import { useMemo } from 'react';
import {
  strapiSearchSamplingChecklistSection,
  type DynamicEntityRow,
} from '../api/strapiDynamicEntity';

export type ChecklistSectionSearchFn = (query: string) => Promise<DynamicEntityRow[]>;

export type ChecklistSectionSearchMap = {
  tujuan: ChecklistSectionSearchFn;
  sni: ChecklistSectionSearchFn;
  parameter: ChecklistSectionSearchFn;
  larutan: ChecklistSectionSearchFn;
  peralatanPengambilan: ChecklistSectionSearchFn;
  peralatanUkur: ChecklistSectionSearchFn;
  peralatanPendukung: ChecklistSectionSearchFn;
  peralatanK3: ChecklistSectionSearchFn;
  cara: ChecklistSectionSearchFn;
  mutu: ChecklistSectionSearchFn;
  transport: ChecklistSectionSearchFn;
  administrasi: ChecklistSectionSearchFn;
  pengawetan: ChecklistSectionSearchFn;
};

function referensiSearch(
  jwt: string,
  kodeKategori: string,
  mode: 'exact' | 'prefix',
): ChecklistSectionSearchFn {
  return (query) =>
    strapiSearchSamplingChecklistSection(jwt, { apiPlural: 'referensis', kodeKategori, mode }, query);
}

/** Stable per-section search calls. Each hits only that section's collection. */
export function useChecklistSectionSearch(jwt: string | null): ChecklistSectionSearchMap | null {
  return useMemo(() => {
    if (!jwt) return null;
    return {
      tujuan: referensiSearch(jwt, 'TUJUAN_SAMPLING', 'exact'),
      sni: (query) => strapiSearchSamplingChecklistSection(jwt, { apiPlural: 'sni-methods' }, query),
      parameter: (query) =>
        strapiSearchSamplingChecklistSection(jwt, { apiPlural: 'parameter-uji-metodas' }, query),
      larutan: referensiSearch(jwt, 'LARUTAN_PENJERAP', 'exact'),
      peralatanPengambilan: referensiSearch(jwt, 'PERALATAN_SAMPLING', 'prefix'),
      peralatanUkur: referensiSearch(jwt, 'PERALATAN_UKUR_LAP', 'exact'),
      peralatanPendukung: referensiSearch(jwt, 'PERALATAN_PENDUKUNG', 'exact'),
      peralatanK3: referensiSearch(jwt, 'PERALATAN_K3', 'exact'),
      cara: referensiSearch(jwt, 'CARA_SAMPLING_', 'prefix'),
      mutu: referensiSearch(jwt, 'PENGENDALIAN_MUTU', 'prefix'),
      transport: referensiSearch(jwt, 'PENGAMANAN_SAMPLING', 'exact'),
      administrasi: referensiSearch(jwt, 'ADMINISTRASI_SAMPEL', 'exact'),
      pengawetan: referensiSearch(jwt, 'PENGAWETAN', 'exact'),
    };
  }, [jwt]);
}
